export default function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8 bg-gradient-to-br from-primary-500/5 to-accent-500/5 rounded-2xl p-8 md:p-10 border border-background-200/60">
          <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500 flex items-center justify-center">
            <i className="ri-smartphone-line text-3xl md:text-4xl text-background-50"></i>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
              移动端吃瓜更便捷
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              随时随地追最新爆料，不错过任何一条热门事件。51吃瓜移动端提供更流畅的浏览体验，支持推送提醒、离线阅读和夜间模式。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center md:justify-start">
              <button className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-950 text-background-50 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-apple-fill"></i>
                iOS 下载
              </button>
              <button className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-950 text-background-50 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-android-fill"></i>
                Android 下载
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}